import { ProjectsVisibilityGroupResponse } from "./response/projects-visibility-group-response-input.model";

export default class DialogDataDto {
    constructor(public field: ProjectsVisibilityGroupResponse, public emailList: string[]) {
        this.field = field;
        this.emailList = emailList;
    }
}